import React from "react";
import { uid } from "uid/single";
import { selectStyle } from "./select.css";
import {
  errorMessageIconStyle,
  errorMessageStyle,
  inputBaseValidationStyle,
  labelStyle,
} from "./input-base.css";
import { Text } from "@vagastec/ensemble-core";
import { useMergedRefs } from "../use-merged-refs";

export const Select = React.forwardRef(
  (
    {
      children,
      label,
      onFocus = () => {},
      onBlur = () => {},
      shouldValidate = false,
      errorMessage = "",
      validate = (isValidInternally) => isValidInternally,
      className,
      ...rest
    },
    ref
  ) => {
    const id = uid();
    const [isAfterBlur, setIsAfterBlur] = React.useState(false);
    const innerRef = React.useRef();

    const mergedRefs = useMergedRefs([innerRef, ref]);

    return (
      <>
        {label ? (
          <label className={labelStyle} htmlFor={id}>
            <Text weight={600}>{label}</Text>
          </label>
        ) : null}
        <select
          className={`${selectStyle} ${
            inputBaseValidationStyle[
              !validate(innerRef.current?.validity.valid) &&
              (isAfterBlur || shouldValidate)
                ? "invalid"
                : "valid"
            ]
          } ${className}`}
          id={id}
          ref={mergedRefs}
          {...rest}
          onFocus={(e) => {
            setIsAfterBlur(false);
            onFocus(e);
          }}
          onBlur={(e) => {
            setIsAfterBlur(true);
            onBlur(e);
          }}
        >
          {children}
        </select>
        {!validate(innerRef.current?.validity.valid) &&
        (isAfterBlur || shouldValidate) ? (
          <div className={errorMessageStyle}>
            <svg
              width={16}
              height={16}
              viewBox="0 0 24 24"
              fill="currentColor"
              className={errorMessageIconStyle}
            >
              <path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2zm4.207 12.793l-1.414 1.414L12 13.414l-2.793 2.793-1.414-1.414L10.586 12 7.793 9.207l1.414-1.414L12 10.586l2.793-2.793 1.414 1.414L13.414 12l2.793 2.793z" />
            </svg>
            <Text size="sm" weight={600} as="p">
              {errorMessage}
            </Text>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
);

Select.displayName = "Select";
